module.exports = __webpack_public_path__ + "static/media/pirates.b182cb1b.mp3";